import type { Flower, Color, Season } from '../../types/game'
import { Worker } from '../shared/Worker'
import { SeasonIcon, ResourceIcon } from '../shared/ResourceIcon'
import { assetUrl } from '../../utils/assets'

interface FlowerCardProps {
  flower: Flower
  currentSeason?: Season
  workerColor?: Color
  selfPollinationSpent?: boolean
  onClick?: () => void
  className?: string
}

const SEASONS = ['spring', 'summer', 'autumn', 'winter'] as const
const YIELD_RESOURCES = ['nectar', 'pollen'] as const

export function FlowerCard({ flower, currentSeason, workerColor, selfPollinationSpent, onClick, className }: FlowerCardProps) {
  return (
    <div
      className={`flower-card ${flower.type === 'tree' ? 'tree' : ''} ${selfPollinationSpent ? 'self-pollination-spent' : ''} ${className ?? ''}`}
      data-flower-id={flower.id}
      onClick={onClick}
    >
      <div className="flower-header">
        <div className="flower-primary-season">
          <SeasonIcon
            season={flower.primary_season}
            inverted
            size="1em"
            className="flower-primary-season-img"
          />
        </div>
        <div className="flower-name">{flower.name}</div>
      </div>

      <div className="flower-img-container">
        <img
          src={assetUrl('images', 'flowers', `${flower.name}_0.png`)}
          alt={flower.name}
          className="flower-card-img"
        />
      </div>

      <div className="flower-powers">
        <div className="flower-qualities">
          {flower.qualities.map((quality) => (
            <div key={quality} className="flower-quality">{quality}</div>
          ))}
        </div>

        <div className="flower-yields">
          {SEASONS.map((season) => {
            const yields = flower.yield_[season] ?? {}
            return (
              <div key={season} className="flower-yield">
                <SeasonIcon season={season} inverted={season === currentSeason} size="0.9em" />
                {YIELD_RESOURCES
                  .filter((resource) => resource in yields)
                  .flatMap((resource) => [
                    <div key={`${season}-${resource}-value`}>{yields[resource]}</div>,
                    <ResourceIcon
                      key={`${season}-${resource}-icon`}
                      resource={resource}
                      size="0.9em"
                    />,
                  ])}
              </div>
            )
          })}
        </div>
      </div>

      {workerColor && (
        <Worker color={workerColor} size="1.8em" />
      )}
    </div>
  )
}
